import React, { useContext, useEffect, useState } from "react";
import { HubContext } from "Redux/Context/context";
import { VegaTabGroup } from "@heartlandone/vega-react";

const SubModuleKeyMap = {
  PendingFeedback: "pending-feedback-activity",
  Closed: "completed-activity",
  Registered: "registered-activity",
};

const RegisteredListSubMenu = ({ onChange }) => {
  const { myActivitiesState, pendFeedbackCountState } = useContext(HubContext);
  const [items, setItems] = useState([
    { label: "Registered Activity", dataTarget: "registered-activity" },
    {
      label: "Pending Feedback Activity",
      dataTarget: "pending-feedback-activity",
      counterBadge: {count: pendFeedbackCountState, color: 'bg-action'}
    },
    { label: "Completed Activity", dataTarget: "completed-activity" },
  ]);
  
  useEffect(() => {
    items[1].counterBadge = {count: pendFeedbackCountState, color: 'bg-action'};
    setItems([...items]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendFeedbackCountState]);

  return (
    <VegaTabGroup
      className="m-b-24"
      selected-tab-data-target={
        SubModuleKeyMap[myActivitiesState.subModule] || "registered-activity"
      }
      variant="secondary"
      gap="size-8"
      show-close-button="false"
      tabItems={items}
      onVegaClick={onChange}
    ></VegaTabGroup>
  );
};

export default RegisteredListSubMenu;
